import Cookies from "js-cookie";

export const cookieAttributes = (expiration) => ({
  expires: expiration,
  secure: true,
  sameSite: "strict",
});

export const getCookieSession = () => {
  try {
    const accessToken = Buffer.from(Cookies.get("accessToken") || "", "base64").toString();
    const idToken = Buffer.from(Cookies.get("idToken") || "", "base64").toString();
    const refreshToken = Buffer.from(Cookies.get("refreshToken") || "", "base64").toString();
    const username = Buffer.from(Cookies.get("username") || "", "base64").toString();
    const orgName = Buffer.from(Cookies.get("orgName") || "", "base64").toString();
    const isUsingExternalAuthProvider = Buffer.from(
      Cookies.get("isUsingExternalAuthProvider") || "",
      "base64",
    ).toString();

    if (
      accessToken &&
      idToken &&
      refreshToken &&
      username &&
      orgName &&
      isUsingExternalAuthProvider
    ) {
      return {
        AccessToken: accessToken,
        IdToken: idToken,
        RefreshToken: refreshToken,
        username,
        orgName,
        isUsingExternalAuthProvider: isUsingExternalAuthProvider === "true",
      };
    }
  } catch {
    // ignore
  }
  return null;
};

export const setCookieSession = (session) => {
  if (!session) {
    return;
  }

  try {
    Cookies.set(
      "accessToken",
      Buffer.from(session.AccessToken).toString("base64"),
      cookieAttributes(30),
    );
    Cookies.set("idToken", Buffer.from(session.IdToken).toString("base64"), cookieAttributes(30));
    Cookies.set(
      "refreshToken",
      Buffer.from(session.RefreshToken).toString("base64"),
      cookieAttributes(30),
    );
    Cookies.set("username", Buffer.from(session.username).toString("base64"), cookieAttributes(30));
    Cookies.set(
      "orgName",
      Buffer.from(session.orgName || "").toString("base64"),
      cookieAttributes(30),
    );
    Cookies.set(
      "isUsingExternalAuthProvider",
      Buffer.from(session.isUsingExternalAuthProvider?.toString() || "false").toString("base64"),
      cookieAttributes(30),
    );
  } catch {
    // ignore
  }
};

export const clearCookieSession = () => {
  Cookies.remove("accessToken");
  Cookies.remove("idToken");
  Cookies.remove("refreshToken");
  Cookies.remove("username");
  Cookies.remove("orgName");
  Cookies.remove("isUsingExternalAuthProvider");
};
